/*
 * ファイルアップロード（api create）
 */
import { apiUpdate } from '@/actions/ApiBaseActions';
export const API_GET_ONE_RESOURCE_INSPECT = 'API_GET_ONE_RESOURCE_INSPECT';
/**
 * sandboxにアップロード済みのファイル監視処理
 * @description サーバーサイドでファイルチェックの最新結果をデータに反映しつつ、ファイルチェックの結果を返す
 * @param path
 * @param meta
 */
export const apiUpdateResourceInspect = ({ path }, meta) => apiUpdate(API_GET_ONE_RESOURCE_INSPECT, `/resource/${path.id}/inspect`, {}, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
